import { clientApiScope, Constants } from "../../../services/web/api.const";
import { useApi, useApiAsync } from "../../../services/web/use-api";
import { CreatePaymentZoneAreaInput, PaymentZoneArea, UpdatePaymentZoneAreaInput } from "../payment-zone-area.type";

export const useGetPaymentZoneAreas = (cityId: string) => {
  const enabled = !!cityId;
  const url = `${Constants.CLIENTS_API_URL}/payment-zones/${cityId}`;
  const options = {
    ...clientApiScope,
    method: "GET",
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };

  const {
    isLoading: loading,
    error,
    data: paymentZoneAreas,
  } = useApi<PaymentZoneArea[]>(url, options, ["payment-zone-areas", cityId], enabled);

  return {
    loading,
    error,
    paymentZoneAreas: paymentZoneAreas ?? [],
  };
};

export const useCreatePaymentZoneArea = () => {
  const url = Constants.CLIENTS_API_URL + "/payment-zones";

  const options = {
    ...clientApiScope,
    method: "POST",
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };

  const {
    mutateAsync: createPaymentArea,
    isPending: loading,
    error,
  } = useApiAsync<void, CreatePaymentZoneAreaInput>(url, options, ["payment-zone-areas"]);

  return {
    createPaymentArea,
    loading,
    error,
  };
};

export const useUpdatePaymentZoneArea = () => {
  const url = Constants.CLIENTS_API_URL + "/payment-zones";

  const options = {
    ...clientApiScope,
    method: "PUT",
    headers: { "Content-type": "application/json; charset=UTF-8" },
  };

  const {
    mutateAsync: updatePaymentArea,
    isPending: loading,
    error,
  } = useApiAsync<void, UpdatePaymentZoneAreaInput>(url, options, ["payment-zone-areas"]);

  return {
    updatePaymentArea,
    loading,
    error,
  };
};

export const useRemovePaymentZoneArea = () => {
  const options = {
    ...clientApiScope,
    method: "DELETE",
    headers: { "Content-type": "application/json; charset=UTF-8" },
    toBody: () => undefined,
  };

  const {
    mutateAsync: removePaymentZoneArea,
    isPending: loading,
    error,
  } = useApiAsync<void, string>(
    (paymentZoneAreaId) => `${Constants.CLIENTS_API_URL}/payment-zones/${paymentZoneAreaId}`,
    options,
    ["payment-zone-areas"],
  );

  return {
    removePaymentZoneArea,
    loading,
    error,
  };
};
